module.exports = __webpack_public_path__ + "static/media/perfGrid.9aab67d9.jpg";